

















import Vue from 'vue';
import Axios  from "axios"
// import HelloWorld from './components/HelloWorld.vue';

interface AddressInfo
{
  id : number,
  index : number,
  address : string,
  isUrlJump : number,
  url : string,
  webContent : string
}

interface GrouInfo
{
  id : number,
  list : AddressInfo
}


export default Vue.extend({
  name: 'app',
  data(){
    return {
      list : new Array,
      webContent : '',
      drawer : false,
      direction: 'btt',
    }
  },
  methods:{
    handleClient(address : AddressInfo){
      
      if(address.isUrlJump > 0){
        
      window.open(address.url, '_blank');
      } else {
          this.webContent = this.html_decode(address.webContent);
          this.drawer = true;
      }
    },
    html_encode(str : string) : string 
    { 
        let s = ""; 
        if (str.length == 0) return ""; 
        s = str.replace(/&/g, "&amp;"); 
        s = s.replace(/</g, "&lt;"); 
        s = s.replace(/>/g, "&gt;"); 
        s = s.replace(/ /g, "&nbsp;"); 
        s = s.replace(/'/g, "&#39;"); 
        s = s.replace(/"/g, "&quot;"); 
            s = s.replace(/\n/g, "<br/>"); 
        return s; 
    },
    html_decode(str  : string) : string 
    { 
        let s = ""; 
        if (str.length == 0) return ""; 
        s = str.replace(/&amp;/g, "&"); 
        s = s.replace(/&lt;/g, "<"); 
        s = s.replace(/&gt;/g, ">"); 
        s = s.replace(/&nbsp;/g, " "); 
        s = s.replace(/&#39;/g, "'"); 
        s = s.replace(/&quot;/g, "\""); 
        s = s.replace(/<br\/>/g, "\n"); 
        return s; 
    }
  },
  mounted(){
    Axios.get<AddressInfo[]>("/index.php?m=rightsnavigation&f=api&recPerPage=1000").then((data)=>{
      const ls  =  data.data
      let info = {id : 0, list :  new Array}
      let rlist = new Array
      let ids = 0;
      for (let index = 0; index < ls.length; index++) {
        info.list.push(ls[index]);
        ids ++;
        if(ids >= 6){
          rlist.push(info);
          info = {id : 0, list :  new Array}
          ids = 0;
        }
      }
      if(info.list.length > 0)
        rlist.push(info);
      this.list = rlist;
    })
  }
});
